import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const SlippageIconComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(--icon-${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__slippage"
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
    >
      <g clipPath="url(#clip0_2402_41205)">
        <path
          d="M2.83325 12.25V8.16667"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.83325 5.83333V1.75"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.5 12.25V7" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.5 4.66667V1.75" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M12.1667 12.25V9.33333"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12.1667 7V1.75" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M1.08325 8.16667H4.58325"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5.75 4.66667H9.25" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M10.4167 9.33333H13.9167"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2402_41205">
          <rect width="14" height="14" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SlippageIcon = withIcon(SlippageIconComponent);
